import React from 'react';
import {observer} from 'mobx-react';
import {OrbitComponent} from '../../base-components/orbit-component/orbit-component';
import {SwiperButtonsBox} from './boxes/wrapper/swiper-buttons.box';
import {SwiperButtonBox} from './boxes/button/swiper-button.box';
import { Button } from '../../../basic-ui-components/button/base/button.component';
import {ISwipeLogicHandler} from "../../../services/arenas/models/swiper-logic-handler/swiper-logic-handler.interface";
import {CyClass} from "../../../../common/cy-classes";


export interface OrbitSwiperButtonsProps {
  analyticsAction: string;
  swiper: ISwipeLogicHandler;
  seeAllButtonUrl: string;
  seoCategory: string;
}



export const OrbitSwiperButtons = observer(class OrbitSwiperButtons extends OrbitComponent<OrbitSwiperButtonsProps> {


  private onSwiperButtonPrevClick = () => {
    this.props.swiper.movePrevious();
  };

  private onSwiperButtonNextClick = () => {
    this.props.swiper.moveNext();
  };

  private _renderMoveNextAndPreviousButtons() {

    if (!this.props.swiper.allowNext && !this.props.swiper.allowPrevious) {
      return null;
    }

    const isTouchDevice = this.services.device.feature.isTouch; // device has touch

    return (<>
      <SwiperButtonBox isTouchDevice={isTouchDevice}>
        <Button
          preset="flatStroked"
          sizeVariant="small"
          fixedSize
          icon={{Component: this.services.theme.currentTheme.icons.backIcon}}
          className="cy-swiper-button-prev"
          onClick={this.onSwiperButtonPrevClick}
          disabled={!this.props.swiper.allowPrevious}
        />
      </SwiperButtonBox>

      <SwiperButtonBox isTouchDevice={isTouchDevice}>
        <Button
          preset="flatStroked"
          sizeVariant="small"
          fixedSize
          icon={{Component: this.services.theme.currentTheme.icons.forwardIcon, reverseOnRTL: true}}
          className="cy-swiper-button-next"
          onClick={this.onSwiperButtonNextClick}
          disabled={!this.props.swiper.allowNext}
        />
      </SwiperButtonBox>
    </>);

  }

  private seeAllClickHandler = () => {
    this.services.analytics.sendAnalytics(this.props.seoCategory, this.props.analyticsAction, 'See_All');

    const url = this.props.seeAllButtonUrl;
    this.services.location.push(url);
  };

  private _renderSeeAllButton() {
    if(this.props.seeAllButtonUrl.length === 0 || this.services.miniOrbit.isEnabled) {
      return null;
    }

    return <SwiperButtonBox>
      <Button
        preset="flatStroked"
        sizeVariant="small"
        fixedSize
        onClick={this.seeAllClickHandler}
        className="cy-see-all-link"
      >
        {this.services.translation.translate('SEE_ALL')}
      </Button>
    </SwiperButtonBox>;
  }

  render() {

    return (
      <SwiperButtonsBox className={CyClass('cy-swiper-buttons')}>
        {this._renderMoveNextAndPreviousButtons()}
        {this._renderSeeAllButton()}
      </SwiperButtonsBox>
    );
  }
});


